module.exports = __webpack_public_path__ + "img/photos.4add2fe4.png";